/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_LongitudeInputs */

const cs_form_longitude = /** @type {(inputs: Form_LongitudeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeměpisná délka`)
};

const en_form_longitude = /** @type {(inputs: Form_LongitudeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longitude`)
};

/**
* | output |
* | --- |
* | "Longitude" |
*
* @param {Form_LongitudeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_longitude = /** @type {((inputs?: Form_LongitudeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_LongitudeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_longitude(inputs)
	return cs_form_longitude(inputs)
});